export const FILTER_TYPE = {
  RECENT: 'recent',
  ALL: 'all',
} as const;

export type FilterTypeState = (typeof FILTER_TYPE)[keyof typeof FILTER_TYPE];

export interface Finding {
  id: string;
  title: string;
  description: string;
  category: 'Cost Reduction' | 'Risk Mitigation' | 'Compliance';
  savings: number;
  savingsLabel: string;
  impact: 'High' | 'Medium' | 'Low';
  effort: 'High' | 'Medium' | 'Low';
  timeline: string;
  confidence: number;
  vendor: string;
}

export interface FindingsProps {
  findings?: Finding[];
  onViewFinding?: (findingId: string) => void;
}
